import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableFooterDataModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import {cfgCaseProcedure} from '../../ar/_models/ar.models';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar/ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CaseFormsService} from '../../case-forms/case-forms.service';
import {Globals} from '../../../globals';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {InsuranceService} from '../insurance.service';
import {ConfigInsurancePayerIdModel} from '../../../models/insurance/config-insurance-payer-id.model';
import {InsuranceCompanyPickerComponent} from '../insurance-company-picker/insurance-company-picker.component';
import {DatePipe} from '@angular/common';
import {InsuranceNoFeeScheduleDialogComponent} from '../insurance-no-fee-schedule-dialog/insurance-no-fee-schedule-dialog.component';

@Component({
    selector: 'app-insurance-payerids',
    templateUrl: './insurance-payerids.component.html',
    styleUrls: ['./insurance-payerids.component.css']
})
export class InsurancePayeridsComponent implements OnInit {

    @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
    footerData: TdoTableFooterDataModel[] = [];
    searchPredicate: (data: any, filter: string) => boolean;

    isLoading: boolean = false;
    cfgInsurancePayers: ConfigInsurancePayerIdModel[] = [];
    payerSelected: ConfigInsurancePayerIdModel;

    isEditMode: boolean = false;

    zselectedRowKeys : any[] =[];

    constructor(
        public dialogRef: MatDialogRef<InsurancePayeridsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private insuranceService: InsuranceService,
        private snackBar: MatSnackBar,
        public globals: Globals,
        private dialog: MatDialog,

    ) {
        this.searchPredicate = (dataSearch: ConfigInsurancePayerIdModel, filter: string) => {
            const dataCode: string = dataSearch.PayerIDperNEIC ? dataSearch.PayerIDperNEIC : '';
            const dataDesc: string = dataSearch.Oragnization ? dataSearch.Oragnization : '';
            return dataCode.toLowerCase().includes(filter) || dataDesc.toLowerCase().includes(filter);
        };

      this.addRecord = this.addRecord.bind(this);
      this.onPayerEditSave = this.onPayerEditSave.bind(this);
      this.onSelectionOfPayer= this.onSelectionOfPayer.bind(this);
    }

    ngOnInit() {
        this.zselectedRowKeys.push(this.data.PayerID);

        this.init();
    }

    init() {

        this.isLoading = true;

        const promises = [
            this.getCfgInsurancePayers(),
        ];

        Promise.all(promises).then((results: any[]) => {
            this.cfgInsurancePayers = results[0];
            this.isLoading = false;

           this.payerSelected = this.cfgInsurancePayers.find(f=> f.PayerID==this.zselectedRowKeys[0]);

        }, err => {
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
        });
    }

  onSelectionOfPayer(e) {

      if(e.selectedRowKeys.length==0)
        return;

      this.zselectedRowKeys = e.selectedRowKeys;

    this.payerSelected = this.cfgInsurancePayers.find(f=> f.PayerID==this.zselectedRowKeys[0]);

  }


  onPayerEditCancel() {

    this.isEditMode=false;
  }
  onPayerEditSave() {

    let a = this.cfgInsurancePayers.find(f=> f.PayerID==this.payerSelected.PayerID);
    a.PayerIDperNEIC =  this.payerSelected.PayerIDperNEIC;
    a.Oragnization = this.payerSelected.Oragnization;
    a.xauditDeleted = this.payerSelected.xauditDeleted;
    this.isEditMode = false;

    // savit to DB
    this.insuranceService.savePayerRecord(a).subscribe(res=> {
      a.PayerID = res.PayerID;
      this.zselectedRowKeys =[];
      this.zselectedRowKeys.push(a.PayerID);

      this.payerSelected = this.cfgInsurancePayers.find(f=> f.PayerID==this.zselectedRowKeys[0]);



    });



  }

  editRecord() {


      this.isEditMode=true;


  }
    addRecord() {

        let  a: ConfigInsurancePayerIdModel = {
            PayerID: 'New',
            PayerIDperNEIC: 'New',
            Oragnization: 'New',
            xauditDeleted: false,
            xauditTableRowID: '',
            xauditModifiedOn : new Date(),
            xauditModifiedBy: '',
            xauditCreatedOn: new Date(),
            xauditCreatedBy: ''
        };
        this.cfgInsurancePayers.push(a);

      this.zselectedRowKeys=[];
      this.zselectedRowKeys.push('New');

      this.payerSelected = this.cfgInsurancePayers.find(f=> f.PayerID =="New");

      this.isEditMode=true;


    }

    deleteRecord()  {
        // this.insuranceService.

    }



    getCfgInsurancePayers() {
        const promise = new Promise((resolve, reject) => {
            this.insuranceService.getAllInsurancePayers()
                .subscribe(resolve, reject);
        });
        return promise;
    }

    SaveSelection(payer: ConfigInsurancePayerIdModel) {

        // update vars
        this.payerSelected = payer;
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    onRowSelected(event: TdoTableSelectionEvent) {
        const selection = this.cfgInsurancePayers.find(p => p === event.model);
        if (selection) {
            this.SaveSelection(selection);
        }
    }

    selectPayer() {

        this.payerSelected = this.cfgInsurancePayers.find(f=> f.PayerID==this.zselectedRowKeys[0]);

        this.dialogRef.close(this.payerSelected);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
